import React, { useMemo } from "react";
import { Link } from "@mui/material";

const URL_PATTERN = /\b(?:https?:\/\/|www\.)[^\s<>"{}|\\^`[\]]+/gi;

function trimUrlTrailingPunctuation(url) {
  let trimmed = url;
  let suffix = "";

  while (/[.,!?;:]$/.test(trimmed)) {
    suffix = trimmed.slice(-1) + suffix;
    trimmed = trimmed.slice(0, -1);
  }

  while (/\)$/.test(trimmed)) {
    const openCount = (trimmed.match(/\(/g) || []).length;
    const closeCount = (trimmed.match(/\)/g) || []).length;
    if (closeCount <= openCount) break;
    suffix = ")" + suffix;
    trimmed = trimmed.slice(0, -1);
  }

  while (/\]$/.test(trimmed)) {
    const openCount = (trimmed.match(/\[/g) || []).length;
    const closeCount = (trimmed.match(/\]/g) || []).length;
    if (closeCount <= openCount) break;
    suffix = "]" + suffix;
    trimmed = trimmed.slice(0, -1);
  }

  return { url: trimmed, suffix };
}

function hrefForUrl(url) {
  return /^www\./i.test(url) ? `https://${url}` : url;
}

/**
 * Renderiza texto plano com URLs http(s)/www clicáveis (nova aba).
 */
const TeamLinkifiedText = ({ content, onAccentBubble = false }) => {
  const nodes = useMemo(() => {
    const text = String(content || "");
    if (!text) return null;

    const parts = [];
    let lastIndex = 0;
    const re = new RegExp(URL_PATTERN.source, "gi");
    let match;

    while ((match = re.exec(text)) !== null) {
      const { url, suffix } = trimUrlTrailingPunctuation(match[0]);
      if (!url) continue;

      if (match.index > lastIndex) {
        parts.push(text.slice(lastIndex, match.index));
      }

      parts.push(
        <Link
          key={`url-${match.index}-${url}`}
          href={hrefForUrl(url)}
          target="_blank"
          rel="noopener noreferrer"
          underline="always"
          onClick={(e) => e.stopPropagation()}
          sx={{
            color: onAccentBubble ? "inherit" : "primary.main",
            fontWeight: onAccentBubble ? 600 : 500,
            wordBreak: "break-all",
            "&:hover": {
              color: onAccentBubble ? "inherit" : "primary.dark",
              opacity: onAccentBubble ? 0.92 : 1,
            },
          }}
        >
          {url}
        </Link>
      );

      if (suffix) {
        parts.push(suffix);
      }

      lastIndex = match.index + match[0].length;
    }

    if (!parts.length) return text;
    if (lastIndex < text.length) parts.push(text.slice(lastIndex));
    return parts;
  }, [content, onAccentBubble]);

  return nodes;
};

export default TeamLinkifiedText;
